import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Link } from '@blueprint/link';
import { ZooplaColor } from '@blueprint/theme';

const StyledMoreWrapper = styled('section')((props) => {
    const {
        theme: { colors }
    } = props;

    return css`
        background-color: ${colors.white};
        margin: 0 auto;
    `;
});

const StyledList = styled('ul')((props) => {
    const {
        theme: { mq, spacing }
    } = props;

    return css`
        display: flex;
        flex-flow: column wrap;
        padding: ${spacing['spacing-4']} ${spacing['spacing-2']};
        list-style: none;
        margin: auto;
        justify-content: center;

        ${mq.large} {
            flex-flow: row nowrap;
            padding: ${spacing['spacing-4']} ${spacing['spacing-1']};
        }
        ${mq.extraLarge} {
            padding: ${spacing['spacing-4']} 0;
        }
    `;
});

const StyledListItem = styled('li')((props) => {
    const {
        theme: { mq, spacing }
    } = props;

    return css`
        display: flex;
        width: 100%;
        margin-bottom: ${spacing['spacing-2']};

        &:last-of-type {
            margin-bottom: 0;
        }

        ${mq.large} {
            margin: 0;
            margin-right: ${spacing['spacing-3']};

            &:last-of-type {
                margin-right: 0;
            }
        }
    `;
});

type StyledBlockProps = {
    color: ZooplaColor;
};

const StyledBlock = styled('div')<StyledBlockProps>((props) => {
    const {
        theme: { colors, spacing, borderRadius }
    } = props;
    return css`
        display: flex;
        padding: ${spacing['24px']};
        background-color: ${colors[props.color]};
        width: 100%;
        border-radius: ${borderRadius['border-radius-2']};
        flex-direction: column;
        justify-content: space-between;

        > * + * {
            margin-top: ${spacing['24px']};
        }
    `;
});

const StyledButton = styled(Link)(() => {
    return css`
        font-weight: bold;
    `;
});

export {
    StyledMoreWrapper,
    StyledList,
    StyledListItem,
    StyledButton,
    StyledBlock
};
